import { SUPPORTED, type Lang } from '../config/locales'
import type { FlagKey } from '../config/flags'
import { isFeatureEnabled } from './featureFlags'

/**
 * Languages an admin can hide from the language menus (admin Sections tab).
 * Hiding ONLY removes the menu entry: /<lang>/ pages keep working for anyone
 * with a link, and Google can still find them (sitemap + hreflang untouched).
 * Only Russian for now - add a flag here to make another language switchable.
 */
const LANGUAGE_FLAGS: Partial<Record<Lang, FlagKey>> = { ru: 'LANG_RU' }

/**
 * The languages the switchers should list. `current` (the page's :lang) is
 * always kept, so a visitor on a hidden language still sees it ticked.
 */
export function menuLanguages(current?: string): Lang[] {
  return SUPPORTED.filter((l) => {
    const flag = LANGUAGE_FLAGS[l]
    return !flag || l === current || isFeatureEnabled(flag)
  })
}
